import { isBlank } from '../../../helpers/common';
import { Base } from '../Base';

export class BehavioralSegments extends Base {
  segmentRequested = null;
  dropDownValue = [];

  isValid() {
    return (
      (Array.isArray(this.dropDownValue) && this.dropDownValue.length > 0) ||
      !isBlank(this.segmentRequested)
    );
  }
}
